import React from 'react';
import { NavLink } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { FaEye, FaCogs, FaPlus } from 'react-icons/fa';
import withRouter from '../../../util/WithRouter';

class AiIntegrationList extends React.Component {
  render() {
    const path = this.props.match.path;

    // Empty list - no integrations yet
    const aiList = [];

    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <div className="row">
            {/* HEADER */}
            <div className="col-md-6 pb-3">
              <h3>AI Integration</h3>
              <p className="text-muted">Configure AI service providers like Gupshup AI, Sarvan AI, etc.</p>
            </div>

            <div className="col-md-6 text-right pb-3">
              <NavLink to={`${path}/add-edit/0`} className="btn btn-success btn-sm">
                <FaPlus /> Add AI Integration
              </NavLink>
            </div>

            {/* TABLE - Empty State */}
            <div className="col-md-12">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>AI Provider Name</th>
                      <th>Configured By</th>
                      <th>Configured Date</th>
                      <th>Last Updated By</th>
                      <th>Last Updated Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {aiList.map((api, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{api.name}</td>
                        <td>{api.createdBy}</td>
                        <td>{api.createdDate}</td>
                        <td>{api.updatedBy}</td>
                        <td>{api.updatedDate}</td>
                        <td>
                          <div className="btn-group btn-group-sm">
                            <NavLink
                              to={`${path}/preview/${api.id}`}
                              className="btn btn-outline-info"
                            >
                              <FaEye /> View
                            </NavLink>
                            <NavLink
                              to={`${path}/configure/${api.id}`}
                              className="btn btn-outline-primary"
                            >
                              <FaCogs /> Configure
                            </NavLink>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(AiIntegrationList);